module.exports = __webpack_public_path__ + "images/cb460d4bbafd3139ee7a9973fe69f843-ETHY4390a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living/ETHY4390a.jpg
// module id = ./src/assets/images/slides/living/ETHY4390a.jpg
// module chunks = 0